import React from 'react';
import { Box, Grid } from '@mui/material';
import { SubmitButton } from './SubmitButton.js';

const FormGrid = ({
  color = 'primary',
  sx,
  childrenList = [[]],
  childrenSx,
  children,
  buttonLabel = 'Submit',
  disabled = false,
  buttonPosition = 'bottom',
  buttonEnabled = true,
  errorMessage,
  xs = 12,
  formik: {
    isSubmitting,
    handleSubmit,
    errors = {},
    values = {}
  } = {}
}) => {
  const Button = () => {
    const _disabled = Boolean(disabled || Object.keys(errors).length || isSubmitting);
    return /*#__PURE__*/React.createElement(SubmitButton, {
      color: color,
      disabled: _disabled,
      isSubmitting: isSubmitting,
      onClick: async () => handleSubmit && (await handleSubmit(values)),
      variant: "contained"
    }, _disabled ? '...' : buttonLabel);
  };
  let _childrenList = childrenList;
  if (buttonEnabled) {
    if (buttonPosition === 'bottom') {
      _childrenList = _childrenList.concat([[/*#__PURE__*/React.createElement(Button, {
        key: "1"
      })]]);
    } else {
      _childrenList = [[/*#__PURE__*/React.createElement(Button, {
        key: "2"
      })]].concat(_childrenList);
    }
  }
  let ErrorMessage = () => /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(errors).map(k => /*#__PURE__*/React.createElement(Box, {
    key: k,
    sx: {
      width: '100%',
      color: 'error.main'
    }
  }, "\u5165\u529B\u691C\u8A3C\u30A8\u30E9\u30FC: ", k, ": ", errors[k])), errorMessage && /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      color: 'error.main'
    }
  }, errorMessage));
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      my: 2,
      ...sx
    }
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, buttonPosition === 'top' && /*#__PURE__*/React.createElement(ErrorMessage, null), _childrenList.map((childrenRow, i) => /*#__PURE__*/React.createElement(React.Fragment, null, childrenRow.map((child, j) => /*#__PURE__*/React.createElement(Grid, {
    key: j,
    xs: xs,
    sm: Number(xs / childrenRow.length)
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      pr: 1,
      height: '100%',
      ...childrenSx
    }
  }, child))))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, children), buttonPosition === 'bottom' && /*#__PURE__*/React.createElement(ErrorMessage, null))));
};

export { FormGrid };
